import React from 'react';
import Paper from '@mui/material/Paper';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SettingsIcon from '@mui/icons-material/Settings';
import PermDataSettingIcon from '@mui/icons-material/PermDataSetting';
import {SystemParameter} from './SystemParameter';
import {ApplicationParameter} from "./ApplicationParameter";
import {Monitoring} from "./Monitoring";
import {Members} from "./Members";
import {Card, CardContent} from "@mui/material";
import {useSelector} from "react-redux";
import {State} from "../reducer";
import {ADMIN_ROLE} from "../const";
import {Navigate, useNavigate,useLocation } from "react-router-dom";
import {MarqueEditorialeParameter} from "./MarqueEditorialeParameter";

export const Parameter: React.FC = () => {
    const auth = useSelector(({auth}: State) => auth);
    const navigate = useNavigate();
    const location = useLocation()


    const tabNumberQuery = new URLSearchParams(location.search).get('tabNumber')
    const tabNumber = tabNumberQuery !== null && tabNumberQuery !== '' ? parseInt(tabNumberQuery) : 0;

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        navigate({
            pathname: location.pathname,
            search: '?tabNumber=' + newValue
        });
    };
    return (auth.roles.indexOf(ADMIN_ROLE) !== -1) ?
        (
            <div>
                <Paper sx={{flexGrow: 1, margin: '1rem 3rem 1rem 3rem'}}>
                    <Tabs
                        value={tabNumber}
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        centered
                    >
                        <Tab label="Paramétrage Système  " icon={<SettingsIcon/>}/>
                        <Tab label="Paramétrage Application" icon={<PermDataSettingIcon/>}/>
                        <Tab label="Marque éditoriale" icon={<PermDataSettingIcon/>}/>
                        <Tab label="Membres" icon={<PersonPinIcon/>}/>
                        <Tab label="Monitoring" icon={<DashboardIcon/>}/>
                    </Tabs>
                </Paper>
                <Card sx={{margin: '0 3rem 2rem 3rem'}}>
                    <CardContent>
                        {
                            tabNumber === 0
                            && <SystemParameter/>
                        }
                        {
                            tabNumber === 1
                            && <ApplicationParameter/>
                        }
                        {
                            tabNumber === 2
                            && <MarqueEditorialeParameter/>
                        }
                        {
                            tabNumber === 3
                            && <Members/>
                        }
                        {
                            tabNumber === 4
                            && <Monitoring/>
                        }
                    </CardContent>
                </Card>
            </div>
        ) : <Navigate to='/'/>
}
